import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import stringToID from '../../util/stringToID';

const Textarea = ({ label, validationMessage, ...props }) => {
  const { required } = props;
  const id = `field-${stringToID(label)}`;
  const errorID = uuid();
  return (
    <div className="form-group">
      <label htmlFor={id}>
        {label} {required && <span>*</span>}
      </label>
      <textarea id={id} {...props} {...validationMessage && { 'aria-describedby': errorID }} aria-invalid={validationMessage ? true : false } />
      {validationMessage && <span id={errorID} className="error-message">{validationMessage}</span>}
    </div>
  );
};

Textarea.propTypes = {
  label: PropTypes.string.isRequired,
};

const Input = ({ type, label, labelClass, validationMessage, idSuffix, ...props }) => {
  const { required } = props;
  const errorID = uuid();
  let id = `field-${stringToID(label)}`;

  if (idSuffix) {
    id = id + idSuffix
  }

  return (
    <div className="form-group">
      <label htmlFor={id} className={labelClass}>
        {label} {required && <span>*</span>}
      </label>
      <input type={type} id={id} {...props} {...validationMessage && {'aria-describedby': errorID}} aria-invalid={validationMessage ? true : false } />
      {validationMessage && <span className="error-message" id={errorID} >{validationMessage}</span>}
    </div>
  );
};

Input.propTypes = {
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export { Textarea, Input };
